import "../../styles/components/fixedInfoFooter.scss";

const FixedInfoFooter = (props) => {
	return (
		<div className="fixed-info-footer flex-column ai-fs jc-fs">
			<span className="footer-title">{props.title}</span>
			<span className="footer-desc">{props.desc}</span>
		</div>
	);
};

export default FixedInfoFooter;
